import { Pagination, Space } from 'antd'
import React, { FC, useState } from 'react'
import { useQuery } from '@apollo/client'
import { translate } from '../../../core'
import { ItemBulkHistoryItemQuery } from '../graphql/item-bulk-history.graphql'
import { ArrowRightOutlined } from '@ant-design/icons'
import { Container } from '../../../core/component'

export type ItemBulkHistoryItemListProps = {
  historyId: number
  itemId?: number
}

export const ItemBulkUpdateHistoryItemList: FC<ItemBulkHistoryItemListProps> = ({historyId, itemId}) => {
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [pageSize, setPageSize] = useState<number>(10)
  const {data, loading} = useQuery(ItemBulkHistoryItemQuery, {
    variables: {
      request: {
        historyId,
        itemId,
        take: pageSize,
        skip: (currentPage - 1) * pageSize,
      }
    }
  })

  const resolveValue = (value: any) => {
    const empty = [null, '']
    if (empty.includes(value))
      return '---'

    if (typeof value === 'boolean')
      return (value as boolean).toString().toUpperCase()

    return value
  }

  return (
    <Container loading={loading}>
      <table className='table'>
        <thead>
        <tr>
          <th>{translate('item')}</th>
          <th>{translate('changes')}</th>
        </tr>
        </thead>
        <tbody>
        {data?.itemBulkUpdateHistoryItemFind.data.map(it => (
          <tr>
            <td>{it.item.sku}</td>
            <td>
              <Space direction='vertical'>
                {it.changes.map(ch => (
                  <Space size='large'>
                    <label className='text-muted'>{ch.display} :</label>
                    <span style={{color: 'red'}}>{resolveValue(ch.previousState)}</span>
                    <ArrowRightOutlined/>
                    <span style={{color: 'green'}}>{resolveValue(ch.updatedState)}</span>
                  </Space>
                ))}
              </Space>
            </td>
          </tr>
        ))}
        </tbody>
      </table>
      <Pagination
        total={data?.itemBulkUpdateHistoryItemFind.count ?? 0}
        defaultCurrent={currentPage}
        pageSize={pageSize}
        onChange={(page, pageSize) => {
          setCurrentPage(page)
          setPageSize(pageSize)
        }}
      />
    </Container>
  )
}